export default {
	methods: 
    {		
	
		nuevoModal()
		{
		  this.resetDataIndex()
		  this.updateGlobal({state: 'openModal/modal/value',    data: true });
		  this.updateGlobal({state: 'openModal/modal/title',    data: 'Nueva nota'});
		  this.updateGlobal({state: 'openModal/modal/modal',    data: 'Nuevo'});
		},
		openPdf()
		{
			window.open( this.url+'/api/pdf/pendientes?ids='+this.datos_razons.toString()+'&mes='+this.mes_periodo.id+'&ano='+this.ano_periodo.id+'&token='+this.token)										
		},
		async getFiltrar()
		{			
			await this.getDataGet({route: 'get_notaspendientes', data: {others: [ ['id_list_mes', this.mes_periodo.id], ['id_list_ano', this.ano_periodo.id]]}})
			// frontend await this.searchGetIdb({tabla:'afiliacion_registro'})
		}
	},
}